import {
	CircularProgress as CircularProgressMui,
} from '@mui/material';
import { BaseProps } from '@componentLibraryWrapper/common';
import { getClassName } from 'components/utilities';
import './circularProgress.scss';

export interface CircularProgressProps extends BaseProps<HTMLSpanElement> {
	color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit',
	size?: string | number,
}

const CircularProgress = ({
	className,
	color='primary',
	size='5em',
	...rest
}: CircularProgressProps) => {
	return (
		<CircularProgressMui 
			{...rest}
			className={getClassName('sm-circularprogress', className)}
			color={color}
			size={size}/>
	)
}

export default CircularProgress;